/** @format */
// PROJECTS
export const projects = [
  {
    title: "Ice Ice Breaker",
    subtitle: "Material UI, React & Firebase",
    description:
      "Ice Ice Breaker helps make a less awkward team ice breaker/introduction experience.",
    image: "./icebreaker.gif",
    link: "https://gc-final-project-47109.web.app",
  },
  {
    title: "TicketFaster",
    subtitle: "TypeScript & React",
    description:
      "Find Tickets to events in your area with a quick search. Try out TicketFaster!  ",
    image: "./event-react-proj.gif",
    link: "https://github.com/CTDior/event-react-project",
  },
  //  Creating a fun way to easily break the ice and spark a low-stress conversation when in a virtual team environment.
  //        EXAMPLE
  // {
  //   title: "React Tracks",
  //   subtitle: "React and Python",
  //   description:
  //     "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
  //   image: "./project-2.gif",
  //   link: "https://reactbootcamp.com",
  // },
];

export const testimonials = [
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "Jesse Hicks",
    company: "Zoozle",
  },
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Ruben Alvarez",
    company: "Dooble.io",
  },
];

//  SKILLS
export const skills = [
  "JavaScript",
  "React",
  "Typescript",
  "HTML/CSS",
  "Git/GitHub",
  "SQL",
  "Firebase",
  "MongoDB",
  "Material UI",
  "Stack Overflow",
];



// WEBPACK FOOTER //
// ./src/data.js